import { Api } from 'models/services/api';
import { UpdateBrandQuery } from 'models/services/graphql';

import { BrandData, BrandDataToSave } from '../index';

type DataToUpdate = {
  id: string;
  input: BrandDataToSave;
};

const RequestQuery = `
  mutation UpdateBrand($id: ID!, $input: BrandInput!) {
    ${UpdateBrandQuery}
  }
`;

type ResponseData = {
  data: {
    updateBrand: BrandData
  }
}

class UpdateGql {

  readonly api: Api<ResponseData>;
  readonly document?: BrandData;

  constructor() {
    this.api = new Api<ResponseData>(RequestQuery);
  }

  async fetch(data: DataToUpdate): Promise<this> {
    const api = await this.api.fetch({ variables: data });
    if (!api.response) throw new Error('invalid response');
    const document = api.response.data.updateBrand;
    return Object.assign(Object.create(this.constructor.prototype), { ...this, api, document });
  }

}

export { UpdateGql };